import { render, staticRenderFns } from "./News_edit.vue?vue&type=template&id=7379c533&scoped=true&"
import script from "./News_edit.vue?vue&type=script&lang=js&"
export * from "./News_edit.vue?vue&type=script&lang=js&"
import style0 from "./News_edit.vue?vue&type=style&index=0&id=7379c533&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7379c533",
  null
  
)

export default component.exports